import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { AppBar, Toolbar } from "@material-ui/core";
import logoHeader from "../../images/gen/logo-menu.svg";
import Menu from "./MenuComponent";

const useStyles = makeStyles((theme) => ({
  root: {
    fixed: "top",
    zIndex: 2,
    position: "relative",
    width: "100%",
  },
  appBar: {
    backgroundColor: "#fff",
  },
  toolbar: {
    color: "white",
    padding: theme.spacing(1),
    display: "flex",
    justifyContent: "space-between",
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(2),
    },
    "& img": {
      maxHeight: 39,
      maxWidth: 145,
    },
  },
  imageHeader: {
    width: 217,
    [theme.breakpoints.down("sm")]: {
      width: "50%",
    },
  },
}));

export default function TopMenuComponent() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <AppBar position="static" className={classes.appBar}>
        <Toolbar className={classes.toolbar}>
          <img alt="Company logo" src={logoHeader} className={classes.imageHeader} />
          <Menu />
        </Toolbar>
      </AppBar>
    </div>
  );
}
